import addressInfo from './addressInfo'

export * from './addressInfo'
export default addressInfo
